<template>
  <nx-fullscreen-dialog :title="$t('message.block.form.facebook.label')" :active="active" @dismiss="dismiss">
    <template slot="toolbar-items">
      <v-btn
        :disabled="!isValid"
        @click="insertBlot"
        color="accent"
        flat
      > {{ buttonTitle }}</v-btn>
    </template>

    <v-container pb-3 fluid>
      <v-layout>
        <v-flex class="md6 offset-md3 sm10 offset-sm1 pt-4">
          <v-layout row wrap>
            <v-flex class="xs12">
              <h2 class="nx-block-headline" v-html="formTitle"></h2>
              <v-text-field
                :error-messages="error"
                :label="$t('message.block.form.facebook.label')"
                :placeholder="$t('message.block.form.facebook.placeholder')"
                autofocus
                v-model="data.url"
              ></v-text-field>
              <iframe
                  v-if="isValid"
                  :src="`https://www.facebook.com/plugins/post.php?href=${data.url}`"
                  allowfullscreen
                  frameborder="0"
                  height="440"
                  width="500"
              ></iframe>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import DialogButton from './DialogButton.vue';
/**
 * FacebookButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-facebook-button',
  extends: DialogButton,
  props: {
    embedUrl: String,
  },
  data() {
    return {
      name: 'facebookEmbed',
      data: {
        url: this.embedUrl || '',
      },
    };
  },
  computed: {
    isValid() {
      return !!this.data.url || this.data.url.includes('facebook');
    },
  },
};
</script>
